
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";
import { GuardTour } from "@/store/guard-tours/types";
import { MapItemData } from "@/store/map-layers/types";

const MapLayers = namespace("mapLayers");

@Component({
	components: {}
})
export default class MapLayerItemListItem extends Vue {
    @MapLayers.Getter("getMapItemIcons") public mapIcons!: any[];

    @Prop({ default: {} }) item: MapItemData;

    private getMapItemIcon(mapItemTypeId: number): string {
		return this.mapIcons[mapItemTypeId];
	}
}
